export enum FonctionTypeUserEnum {
  RGPD_REFERANT = -1,
  INFORMATICIEN = 1,
  REPRESENTANT_LEGAL = 2,
  TRANSACTIONNAIRE = 3,
  DIRECTEUR_COMMERCIAL = 4,
  DIRECTEUR_AGENCE = 5,
  COMPTABLE = 6,
  GESTIONNAIRE = 7,
  ASSISTANT = 8,
  JURISTE = 9,
  AUTRE = 10,
  DIRECTEUR_ADMINISTRATIF_FINANCIER = 11,
  RESPONSABLE_SERVICE = 12,
  SECRETAIRE = 13,
  AGENT_COMMERCIAL = 14,
}
